import React from 'react';
import { Link } from 'react-router-dom';
import ProgressBar from "@ramonak/react-progress-bar";

export const Header = ({step, name, max}) => (
    <>
    <div className="inner-header bg-light">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-sm-6 text-center text-sm-start mb-2 mb-sm-0">
            <h1 className="breadcrumb-title mb-0">{name} </h1>
          </div>
          <div className="col-sm-6">
            <ol className="breadcrumb d-flex justify-content-center justify-content-sm-end ms-auto">
              <li className="breadcrumb-item"><Link to={"/"}><i className="fas fa-home me-1"></i>Home</Link></li>
              <li className="breadcrumb-item active"><span>{name} </span></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
      <div className="container mt-4">
      <ProgressBar bgColor="#a02c2f" completed={Math.round(((step*100)/max))} />
    </div>
      </>
)